export const classifierAppliesToSpan = (detection, span) => {
  if (!detection || !span?.span_id) return false;

  const ids = new Set();
  if (detection.span_id) ids.add(detection.span_id);
  if (detection.primary_span_id) ids.add(detection.primary_span_id);
  if (Array.isArray(detection.evidence_span_ids)) {
    detection.evidence_span_ids.forEach(id => {
      if (id) ids.add(id);
    });
  }

  // Rows with no span identity are trace-level; show them on the root span.
  if (ids.size === 0) return !span.parent_span_id;
  return ids.has(span.span_id);
};

const detectionKey = (detection) => {
  if (detection?.id) return `id:${detection.id}`;
  return [
    detection?.classifier_key || detection?.metric || '',
    detection?.classifier_version || '',
    detection?.detector_version || '',
    detection?.span_id || '',
    detection?.primary_span_id || '',
    Array.isArray(detection?.evidence_span_ids) ? detection.evidence_span_ids.join(',') : '',
    detection?.primary_event_key || '',
  ].join('|');
};

const normalizeDetectionForSpan = (detection, spanId) => ({
  ...detection,
  span_id: detection?.span_id || spanId,
  confidence: detection?.confidence ?? detection?.score,
});

export const getDetectionsForSpan = (span, traceDetections = []) => {
  if (!span) return [];

  const ownDetections = Array.isArray(span.detections)
    ? span.detections.filter(detection => !detection.span_id || detection.span_id === span.span_id)
    : [];

  const applicableTraceDetections = Array.isArray(traceDetections)
    ? traceDetections.filter(detection =>
      (detection?.status === 'detected' || detection?.detected) &&
      classifierAppliesToSpan(detection, span)
    )
    : [];

  const seen = new Set();
  return [...ownDetections, ...applicableTraceDetections]
    .map(detection => normalizeDetectionForSpan(detection, span.span_id))
    .filter(detection => {
      const key = detectionKey(detection);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
};
